import { useAuth } from './hooks/useAuth';
import { Dashboard } from './components/Dashboard';
import { LoginPage } from './components/LoginPage';

export default function App() {
  const { isAuthenticated, user, loading, login, logout } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-gray-700 border-t-blue-500 rounded-full animate-spin-slow" />
          <p className="text-sm text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage onLogin={login} />;
  }

  return <Dashboard user={user} onLogout={logout} />;
}
